<template>
  <section class="formato">
    <Ano :ano="ano" />
    <div class="formato__warpper" :id="ano">
      <div class="container">
        <div class="formato__warpper__item">
          <h2>Ampliação nos EUA e no Brasil</h2>
          <p>
            Ao adquirir o controle da <strong>Pilgrim’s Pride</strong>, a JBS
            marca sua entrada no setor de aves e preparados à base de frango. A
            Companhia amplia significativamente sua presença nos Estados Unidos,
            passando a empregar mais de 70 mil colaboradores naquele país.
          </p>
          <p>
            No Brasil, a incorporação do Bertin representa a consolidação da
            Companhia como líder no segmento de bovinos e permite o início no
            setor de processamento de couros wet blue e semiacabados, passando a
            atender as exigentes indústrias automobilística e moveleira, além de
            diversas fábricas de calçados ao redor do mundo.
          </p>
          <img
            src="../assets/img/2009/2009-1.png"
            alt=""
            @click="
              openLink(
                'https://acervo.estadao.com.br/publicados/2009/09/17/g/20090917-42338-spo-41-eco-b17-not-qahweeg.jpg'
              )
            "
          />
        </div>
        <div class="formato__warpper__item--black">
          <div class="images">
            <img
              src="../assets/img/2009/2009-2.png"
              alt=""
              @click="
                openLink(
                  'https://acervo.estadao.com.br/publicados/2009/04/17/g/20090417-42185-spo-77-ger-h7-not-xppswag.jpg'
                )
              "
            />
            <img
              src="../assets/img/2009/2009-3.png"
              alt=""
              @click="
                openLink(
                  'https://acervo.estadao.com.br/publicados/2009/03/22/g/20090322-42159-spo-58-cid-c9-not-xwsxsag.jpg'
                )
              "
            />
          </div>
          <div>
            <h2>
              Na contramão, o <strong><i>slow-food</i></strong>
            </h2>
            <p>
              Ainda na resistência ao fast-food, outro movimento que apareceu
              com força na década de 2000 e segue crescendo é o
              <strong><i>slow-food</i></strong
              >. Mais do que apenas defender refeições longas, o movimento
              criado pelo italiano Carlo Petrini prega uma maior apreciação dos
              pratos e um equilíbrio nas relações entre a comida, os produtores
              de alimentos e o meio ambiente.
            </p>
            <span
              ><i class="icon-eye"></i
              ><strong>clique nas imagens para ampliar</strong></span
            >
          </div>
        </div>
      </div>
    </div>
  </section>
  <vue-easy-lightbox
    :visible="visibleRef"
    @hide="onHide"
    :imgs="imgsRef"
    :index="indexRef"
  ></vue-easy-lightbox>
</template>
<script>
import Ano from "./Ano.vue";
import VueEasyLightbox from "vue-easy-lightbox";
import { defineComponent } from "vue";

export default defineComponent({
  components: { Ano, VueEasyLightbox },
  props: ["ano"],
  data() {
    return {
      visibleRef: false,
      indexRef: 0,
      imgsRef: [],
    };
  },
  methods: {
    onShow() {
      this.visibleRef = true;
    },
    onHide() {
      this.visibleRef = false;
    },
    openLink(link) {
      window.open(link, "_blank");
    },
  },
});
</script>

<style scoped lang="scss">
.formato {
  .container {
    min-height: 100vh;
    scroll-snap-align: start;
    padding-top: 100px;
    display: grid;
    grid-template-columns: 590px 1fr;
    justify-content: space-between;
    gap: 33px;
    align-items: center;
    @include media("<=desktop") {
      grid-template-columns: 1fr;
    }
  }
  &__warpper {
    position: relative;

    &__item {
      position: relative;
      @include media("<=desktop") {
        padding: 0 20px;
      }
      h2 {
        color: color(cWhite);
        font-family: font(primary);
        font-size: 2.5rem;
        font-style: normal;
        font-weight: 700;
        line-height: 110.5%;
      }
      p {
        color: color(cWhite);
        font-family: font(primary);
        font-size: 1.125rem;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
        margin: 20px 0 30px;
      }
      img {
        cursor: pointer;
        margin-left: auto;
        display: block;
        transition: 0.3s ease-in-out;
        &:hover {
          transform: scale(1.1);
        }
      }

      &--black {
        padding-block: 50px;
        display: flex;
        gap: 24px;
        @include media("<=desktop") {
          display: block;
          padding: 20px;
          position: relative;
        }

        span {
          display: block;
          top: 450px;
          width: 65px;
          color: color(cBlue4);
          margin-top: 100px;
          @include media("<=desktop") {
            position: absolute;
            top: 200px;
          }
          strong {
            color: color(cBlue4);
            font-family: font(primary);
            font-size: 0.75rem;
            font-style: normal;
            font-weight: 400;
            line-height: 116.5%;
            background: color(cGreen);
          }
          i {
            display: block;
            font-size: 1.3rem;
            @include media("<=desktop") {
              color: color(cWhite);
            }
          }
        }
        .images {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          justify-content: flex-end;
          gap: 20px;
          min-width: 250px;
          img {
            transition: 0.3s ease-in-out;
            cursor: pointer;
            &:hover {
              transform: scale(1.1);
            }
          }
        }
        p {
          color: color(cText);
          font-family: font(primary);
          font-size: 0.875rem;
          font-style: normal;
          font-weight: 400;
          line-height: 140%;
          @include media("<=desktop") {
            color: color(cWhite);
          }
        }
        h2 {
          color: color(cText);
          font-family: font(primary);
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 140%;
          text-transform: uppercase;
          max-width: 371px;
          margin-bottom: 10px;
          @include media("<=desktop") {
            color: color(cWhite);
            margin-top: 50px;
          }
        }
        blockquote {
          color: color(cBlue);
          font-family: font(primary);
          font-family: JBS Text;
          font-size: 1rem;
          font-style: normal;
          font-weight: 700;
          line-height: 135%;
          position: relative;
          max-width: 370px;
          margin: 10px auto;
          &::before {
            content: "\e901";
            font-family: "icomoon" !important;
            display: block;
            font-size: 1rem;
            line-height: initial;
            margin-bottom: 17px;
          }
        }
      }
    }
    &::after {
      content: "";
      background: url("../assets/img/2009/2009-fundo.jpg");
      width: 60%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: -1;
      background-repeat: no-repeat;
      background-size: cover;
      @include media("<=desktop") {
        width: 100%;
        background-position: right;
      }
    }
  }
}
</style>
